import React, { useState, useContext } from "react";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import Multiselect from "multiselect-react-dropdown";
import { errorResponseMessage } from "../shared/const.prop";

const MentorFeedback = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [feedback, setFeedback] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedback({ ...feedback, [name]: value });
  };

  const feedbackHandler = async () => {
    let payload = {
      userId: data?.mentee_id,
      subject: data?.expertise,
      appointmentId: data?.id,
      ...feedback,
    };
    try {
      const getFeedback = await axiosHttp.post(`mentor-testimonials`, {
        ...payload,
      });
      if (getFeedback.status === 201) {
        appContext.updateModalState();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return (
    <div className="modal-body">
      <div className="card card-modal h-auto">
        <div className="card-body">
          <div class="form-group">
            <label for="objectives_of_the_session">
              1.Were the objectives of the session clearly defined and
              communicated?
            </label>
            <select
              class="form-control"
              name="objectives_of_the_session"
              id="objectives_of_the_session"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
              <option value="N/A">N/A</option>
            </select>
          </div>
          <div class="form-group">
            <label for="user_friendly_scheduling">
              2.How user-friendly is the application for scheduling and
              conducting mentoring sessions?
            </label>
            <select
              class="form-control"
              name="user_friendly_scheduling"
              id="user_friendly_scheduling"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value="Very User-Friendly">Very User-Friendly</option>
              <option value="Somewhat User-Friendly">
                Somewhat User-Friendly
              </option>
              <option value="Not User-Friendly">Not User-Friendly</option>
            </select>
          </div>
          {/* <div class="form-group">
            <label for="technical_issues_using">
              3.Did you encounter any technical issues while using the
              application during the session?
            </label>
            <select
              class="form-control"
              name="technical_issues_using"
              id="technical_issues_using"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value=" No Technical Issues"> No Technical Issues</option>
              <option value="Minor Technical Issues">
                Minor Technical Issues
              </option>
              <option value="Major Technical Issues">
                Major Technical Issues
              </option>
            </select>
          </div> */}
          <div class="form-group">
            <label for="engaged_during_the_session">
              3.How engaged was the expertise during the session?
            </label>
            <select
              class="form-control"
              name="engaged_during_the_session"
              id="engaged_during_the_session"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value=" Actively Engaged"> Actively Engaged</option>
              <option value="Somewhat Engaged">Somewhat Engaged</option>
              <option value="Not Engaged">Not Engaged</option>
            </select>
          </div>
          <div class="form-group">
            <label for="user_friendly_teaching_and_interacting">
              4.How user-friendly is the application for teaching and
              interacting with Expertise?
            </label>
            <select
              class="form-control"
              name="user_friendly_teaching_and_interacting"
              id="user_friendly_teaching_and_interacting"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value="Very User-Friendly">Very User-Friendly</option>
              <option value="Somewhat User-Friendly">
                Somewhat User-Friendly
              </option>
              <option value="Not User-Friendly">Not User-Friendly</option>
            </select>
          </div>
          <div class="form-group">
            <label for="technical_issues_teaching">
              5.Did you encounter any technical issues while using the
              application during the teaching session?
            </label>
            <select
              class="form-control"
              name="technical_issues_teaching"
              id="technical_issues_teaching"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value=" No Technical Issues"> No Technical Issues</option>
              <option value="Minor Technical Issues">
                Minor Technical Issues
              </option>
              <option value="Major Technical Issues">
                Major Technical Issues
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="discussions_activities_or_exercises">
              6.How actively did the expertise participate in discussions,
              activities, or exercises?
            </label>
            <select
              class="form-control"
              name="discussions_activities_or_exercises"
              id="discussions_activities_or_exercises"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value=" Actively Participated">
                {" "}
                Actively Participated
              </option>
              <option value="Somewhat Participated">
                Somewhat Participated
              </option>
              <option value="Minimally Participated">
                Minimally Participated
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="teaching_experience">
              7.How satisfied are you with the overall teaching experience,
              including the session, application, and expertise interaction?
            </label>
            <select
              class="form-control"
              name="teaching_experience"
              id="teaching_experience"
              required
              onChange={handleChange}
            >
              <option value="">Please Select</option>
              <option value=" Very Satisfied"> Very Satisfied</option>
              <option value="Satisfied">Satisfied</option>
              <option value="Neutral">Neutral</option>
              <option value="Dissatisfied">Dissatisfied</option>
              <option value="Very Dissatisfied">Very Dissatisfied</option>
            </select>
          </div>
          <div class="form-group">
            <label for="description">
              8. Additional suggestion : Please provide any suggestions you have
              for improving the teaching sessions, the application, or any other
              relevant aspect(optional)
            </label>
            <textarea
              class="form-control"
              name="description"
              id="description"
              rows="4"
              maxlength="50"
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-2 mb-3">
        <button
          type="button"
          class="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={() => appContext.updateModalState()}
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-outline-primary modal-btn"
          disabled={Object.keys(feedback).length === 0}
          onClick={feedbackHandler}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default MentorFeedback;
